<template>
  <modal :show="showModal" name="modal" @close="handleClose">
    <template #title>
      <slot name="header">
        {{ header }}
      </slot>
    </template>

    <template #content>
      <slot name="content">
        {{ content }}
      </slot>
    </template>

    <template #footer>
      <form-button type="button" :class="cancelButtonClasses" @click="handleClose" :value="trans('common.cancel')"/>

      <form-button class="ml-3"
                   :class="confirmButtonClasses"
                   @click.prevent="handleConfirm"
                   :processing="!showModal"
                   :value="confirmButtonText"/>
    </template>
  </modal>
</template>

<script>
import Modal from "@/components/Shared/Modal";
import FormButton from "@/components/Shared/Form/Button";
import Loader from "@/components/Shared/Loader.vue";

export default {
  name: 'ConfirmationTermsAndServiceModal',

  components: {
    Loader,
    FormButton,
    Modal
  },

  props: {
    showModal: {
      type: Boolean,
      required: true,
    },

    header: {
      type: String,
      required: true,
    },

    content: {
      type: String,
      required: true,
    },

    confirmButtonText: {
      type: String,
      default: 'Confirm',
    },

    type: {
      type: String,
      default: 'primary',
    },

    processing: {
      type: Boolean,
      default: false,
    }
  },

  mounted() {
    this.$vfm.show('modal');
  },

  computed: {
    confirmButtonClasses() {
      return this.type === 'primary' ? '' : 'button_danger';
    },

    cancelButtonClasses() {
      return this.type === 'primary' ? 'button_hollow button_secondary' : 'button_cancel';
    },
  },

  methods: {
    handleClose() {
      this.$emit('close');
    },

    handleConfirm() {
      this.$emit('confirm');
      this.handleClose();
    },
  },
};
</script>
